import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";

import { DEFAULT_PAGE_SIZE } from "@/shared/constants/pagination";

import * as flowApi from "./api";

export const flowQueryKeys = {
  all: ["flow"] as const,
  rules: ["flow", "rules"] as const,
  rule: (id: string) => ["flow", "rules", id] as const,
  ruleRuns: (id: string) => ["flow", "rules", id, "runs"] as const,
  ruleRecentRun: (id: string) => ["flow", "rules", id, "recent-run"] as const,
  itemRuns: (id: string) => ["flow", "items", id, "runs"] as const,
};

export function getFlowRulesQueryOptions() {
  return queryOptions({
    queryKey: flowQueryKeys.rules,
    queryFn: flowApi.listFlowRules,
  });
}

export function getFlowRuleQueryOptions(id: string) {
  return queryOptions({
    queryKey: flowQueryKeys.rule(id),
    queryFn: () => flowApi.getFlowRule(id),
    enabled: Boolean(id),
  });
}

export function getFlowRuleRunsInfiniteQueryOptions(id: string) {
  return infiniteQueryOptions({
    queryKey: flowQueryKeys.ruleRuns(id),
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      flowApi.listFlowRunsByRule(id, {
        page: pageParam,
        limit: DEFAULT_PAGE_SIZE,
      }),
    getNextPageParam: (lastPage, _pages, lastPageParam) =>
      lastPage.runs.length === DEFAULT_PAGE_SIZE
        ? lastPageParam + 1
        : undefined,
    enabled: Boolean(id),
  });
}

export function getRecentFlowRunQueryOptions(id: string) {
  return queryOptions({
    queryKey: flowQueryKeys.ruleRecentRun(id),
    queryFn: () => flowApi.listFlowRunsByRule(id, { page: 1, limit: 1 }),
    enabled: Boolean(id),
  });
}

export function getItemFlowRunsInfiniteQueryOptions(id: string, enabled = true) {
  return infiniteQueryOptions({
    queryKey: flowQueryKeys.itemRuns(id),
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      flowApi.listFlowRunsByItem(id, {
        page: pageParam,
        limit: DEFAULT_PAGE_SIZE,
      }),
    getNextPageParam: (lastPage, _pages, lastPageParam) =>
      lastPage.runs.length === DEFAULT_PAGE_SIZE
        ? lastPageParam + 1
        : undefined,
    enabled: enabled && Boolean(id),
  });
}
